import React, { Fragment, useContext } from "react";
import DataTable from "react-data-table-component";
import { getInvoicesColumns } from "../../../Data/Booking/InvoiceDetails";
import { DropdownItem, Input } from "reactstrap";
import ActionOptions from "../../Common/Component/ActionOptions";
import CommonToolTip from "../../Common/Component/CommonToolTip";
import { Link } from "react-router-dom";
import { Spinner } from "../../../AbstractElements";
import CustomizerContext from "../../../_helper/Customizer";

const InvoicesTable = ({
    tableData,
    setShowApiLoader,
    fetchTableData,
    paginationPerPage,
    paginationTotalRows,
    onChangePage,
    onChangeRowsPerPage,
    selectedTrips,
    handleSelectTrip,
    handleSelectAllTrips,
    isAllChecked,
    loader
}) => {
    const {mix_background_layout} = useContext(CustomizerContext)
    const processData = tableData.map((element, index) => {
        return {
            action: (
                <input
                    type="checkbox"
                    checked={selectedTrips.includes(element.tripId)}
                    onChange={(value) => handleSelectTrip(value, element.tripId)}
                />
            ),
            megaCabsBookingNo: element.megaCabsBookingNo ? <Link
                to={`${process.env.PUBLIC_URL}/bookings/invoice-correction`}
                state={{ bookingNo: element.megaCabsBookingNo }}
            >
                {element.megaCabsBookingNo}
            </Link> : "-",
            pickUpAddress: element.pickUpAddress ? (
                <>
                    <span
                        id={"pickUpAddress" + index}
                        style={{
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {element.pickUpAddress}
                    </span>
                    <CommonToolTip
                        options={{
                            placement: "left",
                            target: "pickUpAddress" + index,
                        }}
                    >
                        {element.pickUpAddress}
                    </CommonToolTip>
                </>
            ) : (
                "-"
            ),
            destAddress: element.destAddress ? (
                <>
                    <span
                        id={"destAddress" + index}
                        style={{
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {element.destAddress.includes("Kempegowda")
                            ? "Kempegowda Airport"
                            : element.destAddress}
                    </span>
                    <CommonToolTip
                        options={{
                            placement: "left",
                            target: "destAddress" + index,
                        }}
                    >
                        {element.destAddress}
                    </CommonToolTip>
                </>
            ) : (
                "-"
            ),
            totalDistanceInKm: element.totalDistanceInKm ? element.totalDistanceInKm : "-",
            totalFare: element.totalFare ? element.totalFare : "-",
            updatedPickUpAddress: element.updatedPickUpAddress ? (
                <>
                    <span
                        id={"updatedPickUpAddress" + index}
                        style={{
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {element.updatedPickUpAddress}
                    </span>
                    <CommonToolTip
                        options={{
                            placement: "left",
                            target: "updatedPickUpAddress" + index,
                        }}
                    >
                        {element.updatedPickUpAddress}
                    </CommonToolTip>
                </>
            ) : (
                "-"
            ),
            updatedDestAddress: element.updatedDestAddress ? (
                <>
                    <span
                        id={"updatedDestAddress" + index}
                        style={{
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {element.updatedDestAddress.includes("Kempegowda")
                            ? "Kempegowda Airport"
                            : element.updatedDestAddress}
                    </span>
                    <CommonToolTip
                        options={{
                            placement: "left",
                            target: "updatedDestAddress" + index,
                        }}
                    >
                        {element.updatedDestAddress}
                    </CommonToolTip>
                </>
            ) : (
                "-"
            ),
            updatedTotalDistanceInKm: element.updatedTotalDistanceInKm ? element.updatedTotalDistanceInKm : "-",
            updatedTotalFare: element.updatedTotalFare ? element.updatedTotalFare : "-",
            status: element.status ? element.status : "-",
        };
    });
    return (
        <Fragment>
            <div className="table-responsive invoice-correction-table">
                <DataTable
                    columns={getInvoicesColumns(handleSelectAllTrips, isAllChecked)}
                    data={processData}
                    center={true}
                    fixedHeader
                    fixedHeaderScrollHeight={"57vh"}
                    pagination
                    paginationPerPage={paginationPerPage}
                    paginationTotalRows={paginationTotalRows}
                    onChangePage={onChangePage}
                    onChangeRowsPerPage={onChangeRowsPerPage}
                    // customStyles={customStyles}
                    paginationServer
                    progressPending={loader}
                    progressComponent={<div className="loader-box" style={{ height: "57vh" }}>
                        <Spinner attrSpinner={{ className: "loader-3", style: { width: "30px", height: "30px", borderColor: "#39B54A", borderBottomColor: "transparent" } }} />
                    </div>}
                    theme={mix_background_layout == "dark-only" ? "dark" : "default"}
                />
            </div>
        </Fragment>
    );
};

export default InvoicesTable;
